import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'WMA',
  version: 1,
  label: 'Weighted Moving Average',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 31,
  inputs: [period('timeperiod', 30)],
  outputs: [line('wma', 'WMA', COLOR.blue)],
  talib: { functions: ['WMA'], expr: 'WMA(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
